/**
 * Input sanitisation helpers.
 *
 * cleanPhone(value)
 *   - Strips any character that is not a digit, +, -, space, or parentheses.
 *   - Caps length at 20 to prevent runaway pastes.
 *   - Returns the cleaned string.
 *
 * Use in <Input> onChange handlers:
 *   onChange={(e) => setForm({ ...form, phone: cleanPhone(e.target.value) })}
 */
export const cleanPhone = (value) => {
  if (value == null) return '';
  return String(value).replace(/[^0-9+\-()\s]/g, '').slice(0, 20);
};
